module.exports = __webpack_public_path__ + "static/media/google_play_br.445ecd84.png";